import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {useUpdateAutoReplyMutation, UpdateAutoReplyInput} from './__generated__/useUpdateAutoReplyMutation.graphql';

const mutation = graphql`
	mutation useUpdateAutoReplyMutation($input: UpdateAutoReplyInput!) {
		updateAutoReply(input: $input) {
			clientMutationId
			autoReply {
				enabled
				fromName
				fromEmail
				bodyHtml
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UpdateAutoReplyInput,
	onCompleted?: (r: useUpdateAutoReplyMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<useUpdateAutoReplyMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'useUpdateAutoReplyMutation'};
